import Prismic from 'prismic-javascript';
import {ENDPOINT} from "../config";

export const REQUEST_PAGE = 'REQUEST_PAGE';
export const RECEIVE_PAGE = 'RECEIVE_PAGE';
export const REQUEST_EVENTS = 'REQUEST_EVENTS';
export const RECEIVE_EVENTS = 'RECEIVE_EVENTS';
export const REQUEST_SITE = 'REQUEST_SITE';
export const RECEIVE_SITE = 'RECEIVE_SITE';
export const REQUEST_ARTICLES = 'REQUEST_ARTICLES';
export const RECEIVE_ARTICLES = 'RECEIVE_ARTICLES';
export const REQUEST_WORKS = 'REQUEST_WORKS';
export const RECEIVE_WORKS = 'RECEIVE_WORKS';
export const REQUEST_SITE_ERROR = 'REQUEST_SITE_ERROR';
export const OPEN_SUBSCRIBE_POPUP = 'OPEN_SUBSCRIBE_POPUP';
export const CLOSE_SUBSCRIBE_POPUP = 'CLOSE_SUBSCRIBE_POPUP';


function requestPage(page) {
  return {
    type: REQUEST_PAGE,
    page: page,
  }
}

function receivePage(page, doc) {
  return {
    type: RECEIVE_PAGE,
    page: page,
    doc: doc
  }
}

function fetchPage(page) {
  return dispatch => {
    dispatch(requestPage(page));
    return Prismic.api(ENDPOINT)
      .then(api => api.query(Prismic.Predicates.at('document.type', page)))
      .then(response => dispatch(receivePage(page, response.results[0])));
  }
}

function shouldFetchPage(state, page_name) {
  const page = state.pages[page_name];
  if (!page) {
    return true;
  } else if (page.isFetching) {
    return false;
  }
  return false;
}

export function fetchPageIfNeeded(page) {
  return (dispatch, getState) => {
    if (shouldFetchPage(getState(), page)) {
      return dispatch(fetchPage(page));
    }
  };
}

function requestWorks() {
  return {
    type: REQUEST_WORKS
  };
}

function receiveWorks(items) {
  return {
    type: RECEIVE_WORKS,
    items: items
  }
}

function fetchWorks() {
  return dispatch => {
    dispatch(requestWorks());
    return Prismic.api(ENDPOINT)
      .then(api => api.query(Prismic.Predicates.at('document.type', 'work'), {orderings: '[my.work.date desc]'}))
      .then(response => {
        dispatch(receiveWorks(response.results));
      });
  };
}

function shouldFetchWorks(state) {
  const works = state.works;
  if (!works.items) {
    return true;
  } else if (works.isFetching) {
    return false;
  }
  return false;
}

export function fetchWorksIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchWorks(getState())) {
      return dispatch(fetchWorks());
    }
  };
}

function requestArticles() {
  return {
    type: REQUEST_ARTICLES
  };
}

function receiveArticles(items) {
  return {
    type: RECEIVE_ARTICLES,
    items: items
  }
}

function fetchArticles() {
  return dispatch => {
    dispatch(requestArticles());
    return Prismic.api(ENDPOINT)
      .then(api => api.query(
        Prismic.Predicates.at('document.type', 'article'),
        {
          orderings: '[my.article.date desc]',
        }
      ))
      .then(response => {
        dispatch(receiveArticles(response.results));
      });
  }
}

function shouldFetchArticles(state) {
  return !state.articles.items;
}

export function fetchArticlesIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchArticles(getState())) {
      return dispatch(fetchArticles());
    }
  }
}

function requestSite() {
  return {
    type: REQUEST_SITE
  };
}

function receiveSite(site) {
  return {
    type: RECEIVE_SITE,
    site: site
  };
}

function requestSiteError() {
  return {
    type: REQUEST_SITE_ERROR,
  };
}

export function fetchSite() {
  return dispatch => {
    dispatch(requestSite());
    return Prismic.api(ENDPOINT)
      .then(api => api.query(Prismic.Predicates.at('document.type', 'site')))
      .then(
        response => {
          dispatch(receiveSite(response.results[0]));
        },
        error => {
          console.error(error);
          dispatch(requestSiteError());
        }
      );
  }
}

export function openSubscribePopup() {
  return {
    type: OPEN_SUBSCRIBE_POPUP,
  };
}

export function closeSubscribePopup() {
  return {
    type: CLOSE_SUBSCRIBE_POPUP,
  }
}

export const ADD_CHAT_OPENED_COUNT = 'ADD_CHAT_OPENED_COUNT';
export function addChatOpenedCount() {
  return {
    type: ADD_CHAT_OPENED_COUNT,
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions.js